export default __webpack_public_path__ + "static/media/jwt.92d47c14.svg";